import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8d77b7d6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "project-page"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "content-panel"
};
const _hoisted_4 = {
  class: "tab-item"
};
const _hoisted_5 = {
  class: "list-container"
};
const _hoisted_6 = {
  class: "tab-item"
};
const _hoisted_7 = {
  class: "list-container"
};
import { onMounted, ref, watchEffect } from 'vue';
import ProjectList from "@/components/project/ProjectList.vue";
import CourseDesignList from "@/components/courseDegin/CourseDesignList.vue";
import { useRoute, useRouter } from "vue-router";
import { SysDictDataControllerService, XiaoniuHomeworkControllerService, XiaoniuProjectControllerService } from "../../generated";
import { SearchOutlined, CodeOutlined, ExperimentOutlined } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectView',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const loading = ref(false);
    //params：/category    query:?后面的cateogry=project
    //从路由中获取参数，如果没有就使用默认值project项目  category=project
    const activeKey = ref(route.query.type || '0');
    const projectList = ref([]);
    const courseDesignList = ref([]);
    const projectListTotal = ref(0);
    const CourseDesignListTotal = ref(0);
    // const pageSizeOptions = ref<string[]>(['8', '16', '24', '32', '40', '48']);
    const initSearchParams = {
      name: "",
      pageNum: 1,
      pageSize: 32,
      type: activeKey.value
    };
    const searchParams = ref(initSearchParams);
    onMounted(() => {
      getProjectList(searchParams.value);
      getCourseDesignList(searchParams.value);
    });
    const getCourseDesignList = Params => {
      XiaoniuHomeworkControllerService.listUsingGet13(Params).then(res => {
        courseDesignList.value = res.rows;
        CourseDesignListTotal.value = res.total;
      });
    };
    watchEffect(() => {
      //浏览器中的name发生了变化，更新searchParams
      //默认查询第一页八条 查询参数是浏览器上的地址
      //监听实时更新路由上的参数
      searchParams.value = {
        name: route.query.name || '',
        pageNum: parseInt(route.query.pageNum) || 1,
        pageSize: parseInt(route.query.pageSize) || 32,
        type: activeKey.value
      };
    });
    //页码改变
    const pageChange = () => {
      if (activeKey.value === '4') {
        getCourseDesignList(searchParams.value);
      } else {
        getProjectList(searchParams.value);
      }
      router.push({
        query: {
          ...searchParams.value,
          type: activeKey.value
        }
      });
    };
    const getProjectList = Params => {
      XiaoniuProjectControllerService.listUsingGet17(Params).then(res => {
        projectList.value = res.rows;
        projectListTotal.value = res.total;
      });
    };
    const dicType = ref("project_type");
    const dictList = ref([]);
    const otherDicLabel = ref('');
    //获取字典数据
    SysDictDataControllerService.dictTypeUsingGet(dicType.value).then(res => {
      if (res.code === 200) {
        dictList.value = res.data;
        dictList.value = dictList.value.filter(item => item.dictValue !== '4' && item.dictValue !== '5');
        const tempLabel = res.data[4]; //完整的数据字典
        otherDicLabel.value = tempLabel.dictLabel;
      }
    });
    //切换标签页
    const onTypeChange = async key => {
      searchParams.value = {
        ...searchParams.value,
        pageNum: 1,
        pageSize: 32,
        type: activeKey.value
      };
      //切换不同的标签获取不同的数据  课设和其他是分开的
      if (activeKey.value === '4') {
        getCourseDesignList(searchParams.value);
      } else {
        getProjectList(searchParams.value);
      }
      //切换不同的标签页只是路由的参数发生变化，更新路由参数
      activeKey.value = key; //切换标签页
      searchParams.value.type = key; //查询参数也要变
      router.push({
        query: {
          ...searchParams.value,
          type: key
        }
      });
    };
    const onSearch = text => {
      searchParams.value = {
        name: text,
        pageNum: 1,
        pageSize: 32,
        type: activeKey.value
      };
      getProjectList(searchParams.value);
      getCourseDesignList(searchParams.value);
      router.push({
        query: {
          ...searchParams.value,
          type: activeKey.value
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_a_input_search = _resolveComponent("a-input-search");
      const _component_MyPagination = _resolveComponent("MyPagination");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_tabs = _resolveComponent("a-tabs");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_input_search, {
        value: searchParams.value.name,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => searchParams.value.name = $event),
        placeholder: "搜索你感兴趣的项目...",
        "enter-button": "",
        size: "large",
        onSearch: onSearch
      }, {
        prefix: _withCtx(() => [_createVNode(_unref(SearchOutlined))]),
        _: 1
      }, 8, ["value"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_a_tabs, {
        activeKey: activeKey.value,
        "onUpdate:activeKey": _cache[5] || (_cache[5] = $event => activeKey.value = $event),
        onChange: onTypeChange,
        size: "large",
        class: "custom-tabs"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dictList.value, item => {
          return _openBlock(), _createBlock(_component_a_tab_pane, {
            key: item.dictValue
          }, {
            tab: _withCtx(() => [_createElementVNode("span", _hoisted_4, [_createVNode(_unref(CodeOutlined)), _createTextVNode(" " + _toDisplayString(item.dictLabel), 1)])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(ProjectList, {
              "project-list": projectList.value,
              "dict-list": dictList.value
            }, null, 8, ["project-list", "dict-list"])]), _createVNode(_component_MyPagination, {
              currentPage: searchParams.value.pageNum,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => searchParams.value.pageNum = $event),
              pageSize: searchParams.value.pageSize,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = $event => searchParams.value.pageSize = $event),
              total: projectListTotal.value,
              onChange: pageChange
            }, null, 8, ["currentPage", "pageSize", "total"])]),
            _: 2
          }, 1024);
        }), 128)), _createVNode(_component_a_tab_pane, {
          key: "4"
        }, {
          tab: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_unref(ExperimentOutlined)), _createTextVNode(" " + _toDisplayString(otherDicLabel.value), 1)])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createVNode(CourseDesignList, {
            "course-design-list": courseDesignList.value
          }, null, 8, ["course-design-list"])]), _createVNode(_component_MyPagination, {
            currentPage: searchParams.value.pageNum,
            "onUpdate:currentPage": _cache[3] || (_cache[3] = $event => searchParams.value.pageNum = $event),
            pageSize: searchParams.value.pageSize,
            "onUpdate:pageSize": _cache[4] || (_cache[4] = $event => searchParams.value.pageSize = $event),
            total: CourseDesignListTotal.value,
            onChange: pageChange
          }, null, 8, ["currentPage", "pageSize", "total"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["activeKey"])])]);
    };
  }
});